export default {
  // Page metadata
  'meta.title': 'Terma Perkhidmatan - timer.today',
  'meta.description': 'Terma Perkhidmatan dan perjanjian penggunaan untuk platform alat pemasa dalam talian timer.today. Ketahui tentang peraturan perkhidmatan kami, hak dan tanggungjawab pengguna.',

  // Page header
  'page.title': 'Terma Perkhidmatan',
  'page.lastUpdated': 'Kemas kini terakhir: {{date}}',
  'page.intro': 'Selamat datang ke timer.today. Terma dan syarat ini menggariskan peraturan dan peraturan untuk penggunaan Laman Web timer.today, yang terletak di timer.today.',

  // Section 1
  'section1.title': '1. Penerimaan Terma',
  'section1.content': 'Dengan mengakses dan menggunakan laman web ini, anda menerima dan bersetuju untuk terikat dengan terma dan peruntukan perjanjian ini. Jika anda tidak bersetuju untuk mematuhi perkara di atas, sila jangan gunakan perkhidmatan ini.',

  // Section 2
  'section2.title': '2. Penerangan Perkhidmatan',
  'section2.intro': 'timer.today menyediakan alat pemasa dalam talian percuma termasuk:',
  'section2.timer': 'Pemasa Kira Detik - Pemasa boleh disesuaikan untuk produktiviti, memasak, dan pengurusan masa',
  'section2.stopwatch': 'Jam Randik - Alat masa ketepatan tinggi untuk sukan, latihan, dan masa yang tepat',
  'section2.worldclock': 'Jam Dunia - Paparan masa sebenar zon waktu global',

  // Section 3
  'section3.title': '3. Lesen Penggunaan',
  'section3.intro': 'Kebenaran diberikan untuk menggunakan timer.today sementara untuk tontonan peribadi, bukan komersial sahaja. Ini adalah pemberian lesen, bukan pemindahan hak milik, dan di bawah lesen ini anda tidak boleh:',
  'section3.item1': 'mengubah atau menyalin bahan',
  'section3.item2': 'menggunakan bahan untuk sebarang tujuan komersial atau untuk sebarang paparan awam',
  'section3.item3': 'cuba kejuruteraan terbalik mana-mana perisian yang terkandung di laman web',
  'section3.item4': 'membuang sebarang hak cipta atau notasi hak milik lain daripada bahan',

  // Section 4
  'section4.title': '4. Privasi dan Data',
  'section4.intro': 'timer.today komited untuk melindungi privasi anda:',
  'section4.item1': 'Kami tidak mengumpul atau menyimpan maklumat peribadi',
  'section4.item2': 'Tetapan pemasa disimpan secara tempatan dalam pelayar anda',
  'section4.item3': 'Kami tidak menjejaki tingkah laku pengguna atau corak penggunaan',
  'section4.item4': 'Tiada kuki digunakan untuk tujuan penjejakan',

  // Section 5
  'section5.title': '5. Penafian',
  'section5.content': 'Bahan di timer.today disediakan atas dasar \'sebagaimana adanya\'. timer.today tidak membuat jaminan, nyata atau tersirat, dan dengan ini menafikan dan menafikan semua jaminan lain termasuk tanpa had, jaminan atau syarat tersirat kebolehdagangan, kesesuaian untuk tujuan tertentu, atau bukan pelanggaran harta intelek atau pelanggaran hak lain.',

  // Section 6
  'section6.title': '6. Batasan',
  'section6.content': 'Dalam apa jua keadaan timer.today atau pembekalnya tidak bertanggungjawab untuk sebarang kerosakan (termasuk, tanpa had, kerosakan untuk kehilangan data atau keuntungan, atau disebabkan gangguan perniagaan) yang timbul daripada penggunaan atau ketidakupayaan untuk menggunakan bahan di timer.today, walaupun timer.today atau wakil yang diberi kuasanya telah diberitahu secara lisan atau bertulis tentang kemungkinan kerosakan tersebut.',

  // Section 7
  'section7.title': '7. Ketepatan Bahan',
  'section7.content': 'Bahan yang muncul di timer.today boleh termasuk kesilapan teknikal, tipografi, atau fotografi. timer.today tidak menjamin bahawa mana-mana bahan di laman webnya adalah tepat, lengkap, atau terkini. timer.today boleh membuat perubahan kepada bahan yang terkandung di laman webnya pada bila-bila masa tanpa notis.',

  // Section 8
  'section8.title': '8. Pengubahsuaian',
  'section8.content': 'timer.today boleh menyemak terma perkhidmatan ini untuk laman webnya pada bila-bila masa tanpa notis. Dengan menggunakan laman web ini, anda bersetuju untuk terikat dengan versi semasa terma perkhidmatan ini.',

  // Section 9
  'section9.title': '9. Maklumat Hubungan',
  'section9.intro': 'Jika anda mempunyai sebarang soalan tentang Terma Perkhidmatan ini, sila hubungi kami di:',
  'section9.email': 'E-mel:',
  'section9.emailSubject': 'Pertanyaan Terma Perkhidmatan - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Hak cipta terpelihara.'
};
